module.exports = __webpack_public_path__ + "images/thumb/missing.png";